import { create } from 'zustand';
import type { AuthUser } from '@services/auth';

// ---------------------------------------------------------------------------
// Auth state — 持久化由 AuthAdapter 管理，Store 仅做 UI 响应层。
// ---------------------------------------------------------------------------

interface AuthState {
  user: AuthUser | null;
  token: string | null;
  isLoggedIn: boolean;
  /** init() 完成前为 false，防止未登录态闪烁 */
  isInitialized: boolean;
  /** iframe 内需等父页面明确返回 auth-state，避免先用空 token 请求场景。 */
  authSettled: boolean;

  // Actions
  setAuth: (user: AuthUser | null, token: string | null, settled?: boolean) => void;
  clearAuth: () => void;
  setInitialized: (settled?: boolean) => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  token: null,
  isLoggedIn: false,
  isInitialized: false,
  authSettled: false,

  setAuth: (user, token, settled = true) =>
    set({
      user,
      token,
      isLoggedIn: !!user && !!token,
      authSettled: settled,
    }),

  clearAuth: () =>
    set({
      user: null,
      token: null,
      isLoggedIn: false,
      authSettled: true,
    }),

  setInitialized: (settled = true) => set({ isInitialized: true, authSettled: settled }),
}));
